import {inject, Injectable} from "@angular/core";
import {AssetSampleApiClient} from "src/app/infrastructure/moovement-api/web-api/asset-sample.api-client";
import {AggregatedAssetState} from "src/app/domain/assets/aggregated-state/aggregated-asset-state";
import {sevenDays} from "src/app/presentation/common/globals";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";
import {LocationStore} from "src/app/domain/samples/location/location.store";
import {
  InternalNotificationsStore,
  InternalNotificationType
} from "src/app/infrastructure/internal-notifications/internal-notifications.store";
import {ascendingAssetSamples} from "src/app/app.config";

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  private internalNotificationsStore = inject(InternalNotificationsStore);
  private locationStore = inject(LocationStore);

  constructor(
    private assetSampleApiClient: AssetSampleApiClient
  ) {}

  loadLocations(id: string, skipAnomalousLocations: boolean, state?: AggregatedAssetState) {
    if (this.locationStore.assetId() === id) return;

    this.locationStore.setAssetId(id);
    const lastLocationSeenAt = this.lastLocation(state);
    const to = lastLocationSeenAt !== undefined ? new Date(lastLocationSeenAt.getTime() + 1000) : new Date();
    const from = new Date(to.getTime() - sevenDays);

    this.assetSampleApiClient.getAssetSamplesBetween<Samples.GPSFix>('Location', [id], from, to).subscribe({
      next: samples => {
        const sortedAssetSamples = samples
          .filter(sample => !skipAnomalousLocations || sample.alertStatusCount !== 1)
          .sort(ascendingAssetSamples());
        this.locationStore.setLocationSamples(sortedAssetSamples);
      },
      error: () => {
        this.locationStore.setAssetId(undefined);
        this.internalNotificationsStore.addNotification("Unable to retrieve locations.", InternalNotificationType.ERROR, false);
      }
    })
  }

  private lastLocation(state?: AggregatedAssetState) {
    if (!state) return;

    if (!state.lastGPSFixAt) return state.lastSeenByBLEScannerAt;
    if (!state.lastSeenByBLEScannerAt) return state.lastGPSFixAt;
    if (state.lastGPSFixAt > state.lastSeenByBLEScannerAt) return state.lastGPSFixAt;

    return state.lastSeenByBLEScannerAt;
  }
}
